import { useQuery } from '@tanstack/react-query';
import type { LeagueEntry, TeamGameDay } from '../../shared/contracts';
import { dayAt, dayKey } from '../../shared/format';
import { memberLeagueQuery, teamQuery } from '../queries';
import { FlavourBadge } from './FlavourBadge';
import { SectionCard } from './SectionCard';
import { GameDayMatches } from './TeamSchedule';

const COPY = {
  week: (week: number) => `Week ${week}`,
};

const CARD = 'w-full max-w-80';

/** This week's game day, or the next one once it has passed. */
export function upcomingGameDay(
  schedule: TeamGameDay[],
  today: string,
): TeamGameDay | null {
  return (
    schedule
      .filter((day) => day.date >= today)
      .sort((a, b) => a.date.localeCompare(b.date))[0] ?? null
  );
}

function LeagueGameDay({
  entry,
  day,
}: {
  entry: LeagueEntry;
  day: TeamGameDay;
}) {
  return (
    <SectionCard
      title={entry.teamName}
      aside={<FlavourBadge flavour={entry.flavour} />}
      className={CARD}
    >
      <div className="flex flex-col px-1">
        <span className="text-ink font-medium">
          {COPY.week(day.week)} · {dayAt(day.matches[0]!.startsAt)}
        </span>
        <span className="text-muted text-sm">
          {[day.venue, day.block].filter(Boolean).join(' · ')}
        </span>
      </div>
      <GameDayMatches day={day} />
    </SectionCard>
  );
}

/** Nothing until the member's next game day loads, so a member without one never sees a placeholder. */
export function HomeLeftColumn() {
  const league = useQuery(memberLeagueQuery());
  const entry = league.data?.league.find((each) => each.current && !each.sub);
  const team = useQuery({
    ...teamQuery(entry?.teamId ?? ''),
    enabled: entry !== undefined,
  });
  const day = team.data
    ? upcomingGameDay(team.data.schedule, dayKey(Date.now()))
    : null;
  return entry && day ? <LeagueGameDay entry={entry} day={day} /> : null;
}
